import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from 'recharts'
import { CSVLink } from 'react-csv'
import { variables } from '@resurs/midas'
import { getText } from '../../../../internal/TextLabels/text'

const COLORS = [
  variables.coreColor,
  variables.controlColorWarning,
  variables.controlColorSuccess,
  variables.controlColorInfo,
  variables.controlColorDanger,
  variables.controlColorStyle,
  variables.controlColor,
]

class DistributedBarChart extends Component {
  getXAxisLabel() {
    let label = getText('statistics.barchart.xAxisLabel')

    if (this.props.period === 'YEAR') {
      label = getText('statistics.barchart.xAxisLabelMonth')
    } else if (this.props.period === 'WEEK') {
      label = getText('statistics.barchart.xAxisLabelDay')
    } else if (this.props.period === 'MONTH') {
      label = getText('statistics.barchart.xAxisLabelDate')
    }

    return label
  }

  bars() {
    let i = -1
    return Object.keys(this.props.data[0]).map(key => {
      i += 1
      return key !== 'name' ? (
        <Bar
          key={key}
          yAxisId="left"
          dataKey={key}
          name={key}
          fill={COLORS[i]}
          fillOpacity={0.6}
          formatter={a => a.toLocaleString()}
          unit={(this.props.unit && ` ${this.props.unit}`) || ''}
        />
      ) : null
    })
  }

  render() {
    return (
      <div>
        <ResponsiveContainer height={500}>
          <BarChart
            width={600}
            maxBarSize={50}
            height={300}
            data={this.props.data}
            margin={{ top: 20, right: 30, left: 50, bottom: 5 }}
          >
            <XAxis dataKey="name" height={40}>
              <Label
                value={this.getXAxisLabel()}
                offset={0}
                position="insideBottomRight"
              />
            </XAxis>
            <YAxis
              yAxisId="left"
              orientation="left"
              tickFormatter={a => a.toLocaleString()}
            >
              <Label
                position="insideTopLeft"
                dx={60}
                dy={-30}
                style={{ textAnchor: 'middle' }}
              >
                {getText('statistics.barchart.yAxisLabel')}
              </Label>
            </YAxis>
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend verticalAlign="top" height={60} />
            {this.bars()}
          </BarChart>
        </ResponsiveContainer>
        <div style={{ textAlign: 'right', fontSize: '1rem' }}>
          <CSVLink
            data={this.props.data}
            filename="barchart.csv"
            target="_blank"
          >
            {this.props.dllink}
          </CSVLink>
        </div>
      </div>
    )
  }
}

DistributedBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  dllink: PropTypes.string,
  period: PropTypes.string.isRequired,
  unit: PropTypes.string,
}

DistributedBarChart.defaultProps = {
  dllink: 'Get CSV-file',
  unit: '',
}

export default DistributedBarChart
